import styled from '@emotion/styled';
import { Button, ButtonVariants, IconNames, rem } from '@triumph/design-system';
import { useState } from 'react';
import { usePermissions } from '@/components/providers/PermissionsContextProvider';
import {
    ELEVATED_PERMISSIONS_REQUIRED_TEXT,
    Feature,
} from '@/components/shared/constants/features';
import { maskValue } from '../../utils/utils';
import { NoMarginParagraph } from '../LabelValuePair/LabelValuePair.StyledComponents';

const Container = styled.span`
    display: inline-flex;
    align-items: center;
    gap: ${rem(8)};
    vertical-align: middle;
`;

const StyledButton = styled(Button)`
    span {
        padding: 0;
    }
`;

interface MaskFieldProps {
    value: string;
    requiredFeatures?: Feature[];
}

export const MaskField = ({ value, requiredFeatures = [] }: MaskFieldProps) => {
    const [show, setShow] = useState(false);
    const { hasFeature } = usePermissions();

    const hasAccess = requiredFeatures.every((feature) => hasFeature(feature));

    if (!hasAccess) {
        return (
            <Container>
                <NoMarginParagraph as="span">
                    {ELEVATED_PERMISSIONS_REQUIRED_TEXT}
                </NoMarginParagraph>
            </Container>
        );
    }

    return (
        <Container>
            <StyledButton
                variant={ButtonVariants.tertiary}
                icon={show ? IconNames.Visibility_Show : IconNames.Visibility_Hide}
                onClick={() => setShow((prev) => !prev)}
                data-testid="mask-toggle"
            />
            {/* FullStory privacy: elements with "me-is-sensitive-mask-me" are masked in session recordings, applied unconditionally so the revealed value is never captured */}
            <NoMarginParagraph as="span" className="me-is-sensitive-mask-me">{show ? value : maskValue(value)}</NoMarginParagraph>
        </Container>
    );
};
